const normalizePass = (pass = {}) => ({
  block_id: pass.block_id ?? null,
  volume_applied_l: pass.volume_applied_l != null ? String(pass.volume_applied_l) : '',
  area_covered_ha: pass.area_covered_ha != null ? String(pass.area_covered_ha) : '',
  date: pass.date || '',
  start_time: pass.start_time || '',
  end_time: pass.end_time || '',
  equipment_cleaned: !!pass.equipment_cleaned,
});

export const serializePasses = (passes = []) => {
  const list = Array.isArray(passes) ? passes : [];
  return list.map(normalizePass);
};

const comparePasses = (left = [], right = []) => {
  const leftSerialized = serializePasses(left);
  const rightSerialized = serializePasses(right);

  return leftSerialized.length === rightSerialized.length
    && JSON.stringify(leftSerialized) === JSON.stringify(rightSerialized);
};

export const canSaveBlock = (currentPasses = [], lastSavedPasses = [], isSaving = false) => {
  if (isSaving) return false;
  return !comparePasses(currentPasses, lastSavedPasses);
};

export const getPendingPassesForBlock = (currentPasses = [], lastSavedPasses = []) => {
  const current = serializePasses(currentPasses);
  const saved = serializePasses(lastSavedPasses);

  return current.filter((pass, index) => {
    const previous = saved[index];
    return !previous || JSON.stringify(pass) !== JSON.stringify(previous);
  });
};
